import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-5 text-center">
      <XCircle className="mb-4 text-taupe" size={56} />
      <h1 className="text-4xl">Checkout cancelled</h1>
      <p className="mt-3 text-taupe">No charge was made. Your dates are still available — pick up where you left off.</p>
      <Link to="/rentals"><Button className="mt-6 rounded-full btn-ink px-6">Back to rentals</Button></Link>
    </div>
  );
}
